import { css } from "@emotion/react";
import { theme } from "./theme";

export const globalStyle = css`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
  }
  html {
    font-size: 62.5%;
    height: 100%;
    font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN",
      "Hiragino Sans", Meiryo, sans-serif;
  }
  body {
    font-size: 1.4rem;
    line-height: 1.5;
    height: 100%;
    color: ${theme.primaryTextColor};
    margin: 0;
  }
  @media print {
    body {
      height: auto;
    }
  }
  #__next {
    height: 100%;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-weight: normal;
  }
  a {
    text-decoration: none;
    color: ${theme.primaryTextColor};
  }
  ul {
    list-style-type: none;
    margin: 0;
  }
`;
